// extracted by mini-css-extract-plugin
export default {"admin-container":"Admin_admin-container__TzCqf","admin-nav":"Admin_admin-nav__lM7Kc"};